/* eslint-disable camelcase */
export enum Event {
  TOGGLE_ENFORCE_2FA_SWITCH = 'Toggle Enforce 2FA switch',
  TOGGLE_UNENFORCE_2FA_SWITCH = 'Toggle Unenforce 2FA switch',
}

export enum UiPosition {
  ENFORCE_2FA_SWITCH = 'Enforced 2FA switch',
}
